<template>
  <div id="app">
    <h1>Shop Cards</h1>
    <FlashCard :users="users" />
  </div>
</template>

<script>
import FlashCard from './components/FlashCard.vue';
import axios from 'axios';

export default {
  name: 'App',
  components: { FlashCard },
  data() {
    return {
      users: [],
    };
  },
  async mounted() {
    await this.fetchUserData();
  },
  methods: {
    async fetchUserData() {
      try {
        const apiUrl = process.env.VUE_APP_API_URL || 'https://workshop-quiz.luke-sandbox.workers.dev';
        const res = await axios.get(`${apiUrl}/api/users`);
        if (res.data?.ok && Array.isArray(res.data.members)) {
          const users = res.data.members.map(u => ({
            id: u.id,
            name: u.name.toUpperCase(),
            image: u.image,
          }));
          for (let i = users.length - 1; i > 0; i--) {
            const j = Math.floor(Math.random() * (i + 1));
            [users[i], users[j]] = [users[j], users[i]];
          }
          this.users = users;
        } else {
          console.error('Bad response shape:', res.data);
        }
      } catch (err) {
        console.error('Error fetching /api/users:', err);
      }
    },
  },
};
</script>

<style>
#app {
  text-align: center;
  margin-top: 32px;
  padding: 0 16px;
  font-family: system-ui, -apple-system, Segoe UI, Roboto, Helvetica, Arial, sans-serif;
}

h1 {
  margin-bottom: 16px;
}
</style>
